/**
 * FolderPlanPreview · 文件夹方案预览组件 (v6 重构 · live/history 统一入口)
 *
 * 单一路径:
 *   · 接受 card: FolderPlanCard + messageId
 *   · 数据归一在 usePlanPreview 内
 *   · UI 渲染交给 FolderPlanPreviewView (纯展示)
 *
 * v6 重构前曾有 LiveVariant (selection 单例 + anchor) 和 HistoryVariant (message
 * 私有) 两条分支; 重构后合并 — 每条 folder_plan card 都自带快照数据, live 和
 * history 共用同一渲染路径。
 *
 * 调用点: MessageAssistant 的 CardSwitch 看到 card.kind='folder_plan' 时挂
 *   <FolderPlanPreview card={card} messageId={message.id} />
 */

import React from 'react'
import type { FolderPlanCard } from '../../../../types/ai-classify'
import FolderPlanPreviewView from './FolderPlanPreviewView'
import { usePlanPreview } from './usePlanPreview'

export interface FolderPlanPreviewProps {
  card: FolderPlanCard
  /** assistant 消息 id · confirm 后写回 card.taskCreated 用 */
  messageId: string
}

const FolderPlanPreview: React.FC<FolderPlanPreviewProps> = ({
  card,
  messageId
}) => {
  const { viewProps } = usePlanPreview(card, messageId)
  return <FolderPlanPreviewView {...viewProps} />
}

export default FolderPlanPreview
